import { Card, Divider, Stack } from '@mantine/core';
import { useSearchFiltersContext } from 'context/SearchFilters.context';
import { useRouter } from 'next/router';
import { Actions, trackAction } from 'utils/amplitude';
import { useEffect } from 'react';
import { handleSelection } from 'utils/filters/filters';
import { PebbleRadio, PebbleRadioGroup } from 'components/ui';
import classes from './CategoryFilter.module.scss';

const CategoryFilter = () => {
  const router = useRouter();

  const { setCategoryLoader, currentCategory, onFilterChange, categories } =
    useSearchFiltersContext();

  useEffect(() => {
    setCategoryLoader(false);
  }, [router.query.category, setCategoryLoader]);

  return (
    <Card pb={0} className={classes.filterCard}>
      <Stack>
        <PebbleRadioGroup
          name="categories filter option"
          label="Categories"
          onChange={(val) => {
            setCategoryLoader(true);
            trackAction(Actions.FILTER_CATEGORY_SELECTED, { category: val });
            handleSelection(val, 'category', onFilterChange);
          }}
          apply_filter_styling={'true'}
          value={currentCategory}
        >
          <Divider className={classes.divider} size="xs" mb="md" />
          <PebbleRadio
            labelPosition="left"
            width={'100%'}
            value={'all-activities'}
            label={'All categories'}
            apply_filter_styling={'true'}
          />
          {categories.map((category) => (
            <PebbleRadio
              labelPosition="left"
              width={'100%'}
              key={category.slug}
              value={category.slug}
              label={category.name}
              apply_filter_styling={'true'}
            />
          ))}
        </PebbleRadioGroup>
      </Stack>
    </Card>
  );
};

export default CategoryFilter;
